import {defineAsyncComponent} from 'vue';

const EstimateThreeYearExpenseBusiness = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/businessEstimate/EstimateThreeYearExpenseBusinessTab.vue'),
);

const SelectThreeYearRevenueBusinessDIPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimate/threeYearEstimate/businessEstimate/revenueBusiness/popup/ThreeYearRevenueBusinessDIPopup.vue'
  ),
);

const SelectThreeYearRevenueBusinessPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateBusiness/revenueBusiness/popup/ThreeYearRevenueBusinessPopup.vue'
  ),
);

const estimateThreeYearSubmitDetail = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/estimateThreeYearSubmit/EstimateThreeYearSubmitDetailPopup.vue'),
);

const BusinessRegularThreeYearPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/businessEstimate/expenseBusiness/popup/BusinessRegularThreeYearPopup.vue'),
);

const BusinessExpenseInvestThreeYearPopup = defineAsyncComponent(() =>
  import(
    '@/views/estimate/threeYearEstimate/businessEstimate/expenseBusiness/popup/BusinessExpenseInvestThreeYearPopup.vue'
  ),
);
const threeYearTab = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/threeYearEstimateFees/ThreeYearFeesTab.vue'),
);
const SelectFeesPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/threeYearEstimateFees/revenueFees/popup/SelectRevenueFeesPopup.vue'),
);

const ThreeYearExpenseInvestPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/threeYearEstimateFees/expenseFees/popup/ThreeYearExpenseInvestPopup.vue'),
);
const ThreeYearExpenseRegularPopup = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/threeYearEstimateFees/expenseFees/popup/ThreeYearExpenseRegularPopup.vue'),
);

const EstimateThreeYearExpenseRegularDetail = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/tabs/CreateEstimate/popup/EstimateThreeYearExpenseRegularDetail.vue'),
);

const ThreeYearEstimateExpenseRegularDetailSTC = defineAsyncComponent(() =>
  import(
    '@/views/estimateFinanceThreeYear/tabs/createEstimate/expenseRegular/ThreeYearEstimateExpenseRegularDetail.vue'
  ),
);

const submitThreeOrFiveYearEstimateMaster = defineAsyncComponent(() =>
  import('@/views/estimate/threeYearEstimate/tabs/submitEstimate/SubmitThreeOrFiveYearEstimateMaster.vue'),
);
const SubmitEstimateFinanceThreeYearMaster = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/tabs/submitEstimate/SubmitThreeOrFiveYearEstimateMaster.vue'),
);
const submitEstArrgrateThreeYearMaster = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/submitEstArrgrateThreeYear/SubmitEstArrgrateThreeYearMaster.vue'
  ),
);

const ThreeYearEstimateBusinessTab = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateBusiness/ThreeYearEstimateBusinessTab.vue'
  ),
);

const EstimateArrgrateThreeYearFeesTab = defineAsyncComponent(() =>
  import('@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateFees/ThreeYearEstimateFeesTab.vue'),
);

const ThreeYearEstimateRegularExpenseTab = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateRegularExpense/ThreeYearEstimateRegularExpenseTab.vue'
  ),
);

const ThreeYearEstimateRegularExpenseWideSector = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateRegularExpense/ThreeYearEstimateRegularExpense.vue'
  ),
);

const ThreeYearEstimateArrgrateInvestTab = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateArrgrateInvest/ThreeYearEstimateArrgrateInvestTab.vue'
  ),
);
const ThreeYearEstimateArrgrateInvestWideSector = defineAsyncComponent(() =>
  import(
    '@/views/estimateArrgrateThreeYear/threeYearEstimate/threeYearEstimateArrgrateInvest/ThreeYearEstimateArrgrateInvestDetail.vue'
  ),
);
const AuditReceiveArrgrateThreeYearNSNNDetail = defineAsyncComponent(() =>
  import('@/views/auditArrgrateThreeYearSTC/AuditReceiveArrgrateThreeYearNSNNDetail.vue'),
);
const AuditEstArrgrateThreeYearInvestDetail = defineAsyncComponent(() =>
  import('@/views/auditArrgrateThreeYearSTC/AuditEstArrgrateThreeYearInvestDetail.vue'),
);

const AuditReceiveArrgrateThreeYearFeesDetail = defineAsyncComponent(() =>
  import('@/views/auditArrgrateThreeYearSTC/AuditReceiveArrgrateThreeYearFeesDetail.vue'),
);
const ThreeYearEstimateExpenseOtherDetail = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/tabs/createEstimate/expenseOther/ThreeYearEstimateExpenseOtherDetail.vue'),
);
const ExpenseOtherTYAddContentPopup = defineAsyncComponent(() =>
  import('@/views/estimateFinanceThreeYear/tabs/createEstimate/expenseOther/popup/ExpenseOtherTYAddContentPopup.vue'),
);

const AuditEstimateArrgrateThreeYearRevenueFeesDetail = defineAsyncComponent(() =>
  import('@/views/auditArrgrateThreeYearSTC/AuditEstimateArrgrateThreeYearRevenueFeesDetail.vue'),
);

const AuditEstimateArrgrateThreeYearExpenseFeesDetail = defineAsyncComponent(() =>
  import('@/views/auditArrgrateThreeYearSTC/AuditEstimateArrgrateThreeYearExpenseFeesDetail.vue'),
);

export function registerThreeYearEstimate(app) {
  app.component('EstimateThreeYearExpenseBusinessTab', EstimateThreeYearExpenseBusiness);
  app.component('ThreeYearEstimateBusinessTab', ThreeYearEstimateBusinessTab);
  app.component('ThreeYearEstimateRegularExpenseTab', ThreeYearEstimateRegularExpenseTab);
  app.component('EstimateArrgrateThreeYearFeesTab', EstimateArrgrateThreeYearFeesTab);
  app.component('ThreeYearRevenueBusinessDIPopup', SelectThreeYearRevenueBusinessDIPopup);
  app.component('ThreeYearRevenueBusinessPopup', SelectThreeYearRevenueBusinessPopup);
  app.component('EstimateArrgrateThreeYearRevenueFeesPopup', SelectFeesPopup);
  app.component('EstimateThreeYearSubmitDetail', estimateThreeYearSubmitDetail);
  app.component('BusinessRegularThreeYearPopup', BusinessRegularThreeYearPopup);
  app.component('BusinessExpenseInvestThreeYearPopup', BusinessExpenseInvestThreeYearPopup);
  app.component('ThreeYearFeesTab', threeYearTab);
  app.component('SelectFeesPopup', SelectFeesPopup);
  app.component('ThreeYearExpenseInvestPopup', ThreeYearExpenseInvestPopup);
  app.component('ThreeYearExpenseRegularPopup', ThreeYearExpenseRegularPopup);
  app.component('EstimateThreeYearExpenseRegularDetail', EstimateThreeYearExpenseRegularDetail);
  app.component('SubmitThreeOrFiveYearEstimateMaster', submitThreeOrFiveYearEstimateMaster);
  app.component('SubmitEstimateFinanceThreeYearMaster', SubmitEstimateFinanceThreeYearMaster);
  app.component('ThreeYearEstimateRegularExpenseWideSector', ThreeYearEstimateRegularExpenseWideSector);
  app.component('SubmitEstArrgrateThreeYearMaster', submitEstArrgrateThreeYearMaster);
  app.component('ThreeYearEstimateArrgrateInvestTab', ThreeYearEstimateArrgrateInvestTab);
  app.component('ThreeYearEstimateArrgrateInvestWideSector', ThreeYearEstimateArrgrateInvestWideSector);
  app.component('AuditReceiveArrgrateThreeYearNSNNDetail', AuditReceiveArrgrateThreeYearNSNNDetail);
  app.component('AuditEstArrgrateThreeYearInvestDetail', AuditEstArrgrateThreeYearInvestDetail);
  app.component('AuditReceiveArrgrateThreeYearFeesDetail', AuditReceiveArrgrateThreeYearFeesDetail);
  app.component('ThreeYearEstimateExpenseRegularDetailSTC', ThreeYearEstimateExpenseRegularDetailSTC);
  app.component('ThreeYearEstimateExpenseOtherDetail', ThreeYearEstimateExpenseOtherDetail);
  app.component('ExpenseOtherTYAddContentPopup', ExpenseOtherTYAddContentPopup);
  app.component('AuditEstimateArrgrateThreeYearRevenueFeesDetail', AuditEstimateArrgrateThreeYearRevenueFeesDetail);
  app.component('AuditEstimateArrgrateThreeYearExpenseFeesDetail', AuditEstimateArrgrateThreeYearExpenseFeesDetail);
}
